import { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { formSubmissionRefs } from "../subjects/formSubmission/refs";

/**
 * A trainer filed the day's report on a trainee.
 */
export const trainerDailyFormV1 = tmsEventKind(
  { category: "training", kind: "trainerDailyForm", version: 1 },
  {
    refs: formSubmissionRefs,
    facts: {
      /** Hours the trainee drove, as the trainer reported them. */
      drivingHours: z.number().nullable(),
    },
  },
);

export const TrainerDailyFormV1Schema = trainerDailyFormV1.schema;
export const TrainerDailyFormV1FactsSchema = trainerDailyFormV1.facts;

export type TrainerDailyFormV1 = z.infer<typeof TrainerDailyFormV1Schema>;
export type TrainerDailyFormV1Facts = z.infer<typeof TrainerDailyFormV1FactsSchema>;

/** Every version of `trainerDailyForm`, keyed by version. What `catalog.ts` places under `training`. */
export const trainerDailyForm = { 1: trainerDailyFormV1 } as const;
